import swal from "sweetalert";
import axiosInstance from "../api";
import { setgetAllEnquiries, setgetsingleEnquiryById } from "../reusable/reusableSlice";

export const getAllEnquiriesListData = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post(`/cms/contact_us_list`, data);
    if (response?.data) {
      dispatch(setgetAllEnquiries(response?.data?.response))
      return response
    } else {
      dispatch(setgetAllEnquiries([]))
    }
  } catch (err) {
    dispatch(setgetAllEnquiries([]))
  }
};

export const getSingleEnquiryById = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`/cms/get_contact_us_by_id/${id}`);
    if (response?.data) {
      dispatch(setgetsingleEnquiryById(response?.data?.response))
    } else {
      dispatch(setgetsingleEnquiryById([]))
    }
  } catch (err) {
    console.error(err);
    dispatch(setgetsingleEnquiryById([]))
  }
};

export const updateEnquiry = (data, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("/cms/update_contact_us", data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      dispatch(getAllEnquiriesListData({
        search_key: "",
        page: 1,
      }));
    }
    else {
      swal({
        text: response?.data?.message,
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    }
return response
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};
